import Card from 'semantic-ui-react/dist/commonjs/views/Card';
import '@purple/semantic-ui-purple-theme/components/card.css';

export default Card;
